import { render, staticRenderFns } from "./GvntTmntAdd.vue?vue&type=template&id=ceaabbf4&scoped=true&"
import script from "./GvntTmntAdd.vue?vue&type=script&lang=js&"
export * from "./GvntTmntAdd.vue?vue&type=script&lang=js&"
import style0 from "./GvntTmntAdd.vue?vue&type=style&index=0&id=ceaabbf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceaabbf4",
  null
  
)

export default component.exports